import {handleSend} from '../post'

const storehouseUpdate600001 = (data) => {
  return handleSend(data, '60', '0001', data.operaType)
}
// 仓库id id
// 商户号 merchId
// 仓库编号 shNo
// 仓库名称 shName
// 备注 description
// 地址 address
// 入库登记及核验可否同一个人 sameChkFlag
// 入库登记和修改可否同一个人 sameMdFlag
// 是否在盘点 stockchecking
// 状态 status
// 状态 statusName
const storehouseList600002 = (data) => {
  data.pageNum = String(data.pageNum)
  data.pageSize = String(data.pageSize)
  return handleSend(data, '60', '0002', '0', 'message')
}

const managerList600003 = (data) => {
  data.pageNum = String(data.pageNum)
  data.pageSize = String(data.pageSize)
  return handleSend(data, '60', '0003', '0', 'message')
}

const manager600004 = (data) => {
  return handleSend(data, '60', '0004', data.operaType)
}

const shelvesUpdate601001 = (data) => {
  return handleSend(data, '60', '1001', data.operaType)
}

const shelvesList601002 = (data) => {
  data.pageNum = String(data.pageNum)
  data.pageSize = String(data.pageSize)
  return handleSend(data, '60', '1002', '0', 'message')
}

export const HxApiStorehouse = {
  storehouseUpdate600001,
  storehouseList600002,
  managerList600003,
  manager600004,
  shelvesUpdate601001,
  shelvesList601002
}



// WEBPACK FOOTER //
// ./src/api/erp/info/storehouse.js